export const ChangeStores = "ChangeStores";
export const AppendStores = "AppendStores";
export const AddReviewLinks = "AddReviewLinks";
